export interface IsharingChangeModel {
  secondaryEICRacf: String;
}

export class SharingChangeModel {
  secondaryEICRacf: String;

  constructor(sharingChangeModel?: IsharingChangeModel) {
    this.secondaryEICRacf = sharingChangeModel.secondaryEICRacf ? sharingChangeModel.secondaryEICRacf : undefined;
  }
}
